module.exports = __webpack_public_path__ + "img/boy.d2de02f0.png";